// Dispatch — superadmin panel page (Management sidebar).
// Won + payment-confirmed orders waiting to be handed over; confirming
// dispatch here is what makes an order 'completed'.

import React from 'react';
import MainLayout from '../components/layout/MainLayout.jsx';
import { PageHeader } from '../components/common/index.js';
import DispatchBoard from '../components/ops/DispatchBoard.jsx';
import { dispatchApi } from '../api/opsApi';

const DispatchPage = () => (
  <MainLayout>
    <PageHeader purpose="Hand over paid orders — dispatch is what completes a sale." />
    {/* canDelete: this is the SUPERADMIN route — the ops twin renders the same
        board without it, so the ops login never sees a delete button. */}
    <DispatchBoard api={dispatchApi} canDelete />
  </MainLayout>
);

export default DispatchPage;
